
import { defineComponent, ref, computed, reactive, toRefs,onMounted, onUpdated, inject } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  components: {
    
  },
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: 'Form',
    },
    data: {
      type: Object,
    },
  },

  setup (props) {
    const form = ref<any>(props.data)
    const store = useStore()
    const roles = ref([])
    const filterOption = (inputValue: any, option: any) => {
      return option.children.join('').toLowerCase().includes(inputValue.toLowerCase());
    }

    const loadRoles = () => {
        store.dispatch('Role/index').then((res:any) => {
            var data = res.data.data
            data.unshift({
                'id': '',
                'name': 'All'
            })
            roles.value = data
        })
        
    }

    onMounted(() => {
        loadRoles()
    })

    return {
      form,
      roles,
      filterOption
    }
  },
})
